"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePronunciationFlashcardsProgress = void 0;
const zod_1 = require("zod");
const PronunciationFlashcardsProgress = zod_1.z.object({
    addedBasicsOfSpellingFlashcards: zod_1.z.number(),
    addedEarTrainingFlashcards: zod_1.z.number(),
    totalBasicsOfSpellingFlashcards: zod_1.z.number(),
    totalEarTrainingFlashcards: zod_1.z.number(),
});
const validatePronunciationFlashcardsProgress = (x) => PronunciationFlashcardsProgress.safeParse(x);
exports.validatePronunciationFlashcardsProgress = validatePronunciationFlashcardsProgress;
//# sourceMappingURL=user_progress.js.map